import styled from 'styled-components';
import EmailsBlockWithAutoAddAnimationComponent from 'core/common/components/EmailsBlockWithAutoAddAnimation';

export const EmailsBlockWithAutoAddAnimation = styled(EmailsBlockWithAutoAddAnimationComponent)`
  margin-top: 30px;
  margin-bottom: 30px;
  background: rgba(60, 56, 215, 0.05);
`;
